import {PwaPromptState} from './pwa-prompt.reducer.types';
import {CANCEL_ADD_TO_HOME_SCREEN, DONE_ADD_TO_HOME_SCREEN} from '../constants/popup.constants';
import {PWA_INSTALL_AVAILABLE, PWA_INSTALLED} from '../constants/pwa.constants';

const initialState: PwaPromptState = {
	isShownOnce: false,
	isAndroidInstallAvailable: false,
	isPWAInstalled: false
};

export const pwaPromptReducer = (previousState = initialState, action): PwaPromptState => {
	switch (action?.type) {
		case CANCEL_ADD_TO_HOME_SCREEN:
		case DONE_ADD_TO_HOME_SCREEN:
			return {
				...previousState,
				isShownOnce: true
			};
			break;

		case PWA_INSTALL_AVAILABLE:
			return {
				...previousState,
				isAndroidInstallAvailable: true
			};
			break;

		case PWA_INSTALLED:
			return {
				...previousState,
				isPWAInstalled: true
			};
			break;

		default:
			return previousState;
	}
};
